import { Injectable } from '@angular/core';
import { BaseService } from '../../abstracts/base.service';
import { ResultModel } from '../../models/result.model';
import { SurveyShareModel } from '../../models/survey/survey-share.model';
import { SurveyModel } from '../../models/survey/survey.model';

@Injectable({
  providedIn: 'root'
})
export class SurveyService extends BaseService {

  listAllForSelect() {
    return this.httpClient.get<ResultModel<SurveyModel[]>>(this.getApiUrl('surveys'));

  }

  listAll(formData:FormData) {
    return this.httpClient.post<ResultModel<SurveyModel[]>>(this.getApiUrl('surveys/list'), formData);
  }

  create(survey: SurveyModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('surveys'), survey);
  }

  update(survey: SurveyModel) {
    return this.httpClient.put(this.getApiUrl('surveys'), survey);
  }

  get(id:string) {
    return this.httpClient.get<{ Survey: SurveyModel }>(this.getApiUrl('surveys/' + id));
  }

  delete(id:string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('surveys/' + id));
  }

  //shared

  createForShare(survey: SurveyShareModel) {
    return this.httpClient.post<ResultModel>(this.getApiUrl('surveys/shared'), survey);
  }

  deleteForShare(id:string) {
    return this.httpClient.delete<ResultModel>(this.getApiUrl('surveys/shared/' + id));
  }

  listAllForShare(pTrainingID, pClassID, pSurveyTypeID) {
    var queryParams = {
      pTrainingID: pTrainingID,
      pClassID: pClassID,
      pSurveyTypeID: pSurveyTypeID
    }
    return this.httpClient.get<ResultModel<SurveyShareModel[]>>(this.getApiUrl('surveys/shared/list?' + this.getQueryString(queryParams)));
  }

}
